import type { ApiTokenViewModel, GetApiTokenDetailViewModel } from "@vintecc/capture-api-types/v1";

import { create } from "zustand";

interface ApiTokenStore {
  token: ApiTokenViewModel | GetApiTokenDetailViewModel | null;
  setToken: (token: ApiTokenViewModel | GetApiTokenDetailViewModel | null) => void;
}

export const useApiTokenStore = create<ApiTokenStore>((set) => ({
  token: null,
  setToken: (token: ApiTokenViewModel | GetApiTokenDetailViewModel | null) => set({ token }),
}));
